import { useEffect, useState } from "react"

import { createPortal } from "react-dom"

interface IFrameProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
    title: string
}

export const IFrame: React.FC<IFrameProps> = ({
    title,
    children,
    ...props
}) => {
    const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);
    const mountNode = iframeRef?.contentWindow?.document?.body

    useEffect(() => {
        const copyStylesToIframe = () => {
            const iframeDocument = iframeRef?.contentDocument;
            const parentDocument = window.document;

            if (iframeDocument && parentDocument) {
                const parentStyles = parentDocument.querySelectorAll("style");
                parentStyles.forEach((stylesheet: HTMLStyleElement) => {
                    const clonedStylesheet = stylesheet.cloneNode(true);
                    iframeDocument.head.appendChild(clonedStylesheet);
                });

                const parentLinks = document.querySelectorAll('link');
                parentLinks.forEach((link: HTMLLinkElement) => {
                    if (link.rel === "stylesheet") {
                        const newLink = link.cloneNode(true);
                        iframeDocument.head.appendChild(newLink);
                    }
                });

                const htmlElement = iframeDocument.querySelector("html");
                if (htmlElement) {
                    htmlElement.style.overflowX = "hidden";
                }
            }
        };

        copyStylesToIframe();
        // eslint-disable-next-line
    }, [mountNode]);

    return (
        // <div {...props}>{children}</div>
        <iframe title={title} {...props} ref={setIframeRef}>
            {mountNode && createPortal(children, mountNode)}
        </iframe>
    )
}
